<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="hidden">
  <section class="row bg-brown">
    <div class="col-lg-4 col-md-3 col-sm-12 pr-0">
      <div class="upload-progress-section ">
        <div>
          <div>
            <img src="assets/images/certificate.png" alt="" class="w-100" />
          </div>
          <div class="my-5 container">
            <h3 class="font24 text-white">Upload Signature</h3>
            <label for="file" class="btn btn-secondary btn-sm mr-3 mt-4 pt-2"
              >Upload</label
            >
            <input type="file" name="file" id="file" class="inputfile" />
          </div>
        </div>
        <div class="mt-auto container font14 text-grey">
          Allowed formats: *MOV *AVI *MPEG4
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-md-3 col-sm-12 bg-white">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <p class="font20 click my-5">
              Create Certificate
            </p>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="d-flex justify-content-end">
              <button
                class="btn btn-outline-secondary btn-sm my-5 mr-4"
                data-toggle="modal"
                data-target="#certificateModal"
              >
                Preview
              </button>
              <button class="btn btn-secondary btn-sm my-5">
                Save
              </button>
            </div>
          </div>
        </div>
        <div class="mt-5">
          <p class="font24 text-grey">Certificate Name</p>
          <textarea
            placeholder="Certifie I"
            class="change-name-textarea form-control"
          ></textarea>
        </div>
        <div class="mb-5">
          <p class="font24 text-grey">Certicate Text</p>
          <textarea
            class="form-control"
            placeholder="Describe the certificate in a couple words"
          ></textarea>
          <span class="font14 text-grey font-light"
            >Let participants know what they have achived in 300 words</span
          >
        </div>
        <div class="col-lg-4 col-sm-12">
          <h3 class="font24 mb-3 text-grey">Role/Designation</h3>
          <textarea
            class="form-control"
            placeholder="e.g Supervising Officer"
          ></textarea>
        </div>
        <div class="d-flex justify-content-between">
          <button class="btn btn-outline-secondary btn-sm my-5">
            Back
          </button>
          <button
            class="btn btn-secondary btn-sm my-5"
            routerLink="/courses/course-details"
          >
            Finish
          </button>
        </div>
      </div>
    </div>
  </section>
</section>
<!-- Modal -->
<div
  class="modal fade"
  id="certificateModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="certificateModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <img src="assets/images/certificate.png" alt="" class="w-100" />
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
